import { render, staticRenderFns } from "./AllocationDetails.vue?vue&type=template&id=25067ec5&scoped=true"
import script from "./AllocationDetails.vue?vue&type=script&lang=js"
export * from "./AllocationDetails.vue?vue&type=script&lang=js"
import style0 from "./AllocationDetails.vue?vue&type=style&index=0&id=25067ec5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25067ec5",
  null
  
)

export default component.exports